module.exports = __webpack_public_path__ + "img/03.f4b246af.png";